import { useState, useEffect } from 'react';
import { signInWithGoogle } from '../firebase';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const API_BASE_URL = "https://api.stinteportal.co";

function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  // If already logged in, redirect to dashboard
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) navigate('/dashboard');
  }, [navigate]);

  const handleGoogleLogin = async () => {
    try {
      const user = await signInWithGoogle();
      if (!user) return;

      const idToken = await user.getIdToken();

      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idToken }),
      });

      const data = await response.json();

      if (data.success) {
        // Save token and user info in sessionStorage
        sessionStorage.setItem("token", idToken);
        sessionStorage.setItem("user", JSON.stringify(data.user));

        // Redirect to dashboard; role-based dashboard logic is handled in App.js
        navigate("/dashboard");
      } else {
        setError(data.message || "Login failed");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong during login.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#ffffff] px-4">
      <div className="text-center space-y-4 w-full max-w-xlg">
        <img
          src={logo}
          alt="Stinte Logo"
          className="w-50 mx-auto mb-10"
        />
        <h1 className="text-2xl font-semibold">
          Sign in to STINTE Portal
        </h1>

        {error && (
          <div className="bg-red-100 text-red-800 border border-red-300 px-4 py-2 rounded-md">
            {error}
          </div>
        )}

        <button
          onClick={handleGoogleLogin}
          className="mt-4 flex items-center justify-center rounded-md px-20 py-5 text-sm font-medium hover:bg-gray-100 border border-gray-300 bg-white mx-auto"
        >
          <img
            src="https://www.svgrepo.com/show/475656/google-color.svg"
            alt="Google"
            className="w-10 h-10 mr-2"
          />
          Continue with Google
        </button>
      </div>
    </div>
  );
}

export default Login;
